import axios from "axios";
import { baseUrl } from "./baseUrl";

// App info API
const api = axios.create({
    baseURL: `${baseUrl}/admin/user`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Create Policy Data
export const createPolicyData = async (data) => {
    try {
        const res = await api.post("/add-policy", data);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// Get app info data (terms & conditions, privacy policy, app info)
export const getPolicy = async () => {
    try {
        const res = await api.get("/list-policy");
        return res.data || [];
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// Update app info data
export const updatePolicy = async (data) => {
    try {
        const res = await api.put("/edit-policy", data);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// Create Policy Data
export const createTnc = async (data) => {
    try {
        const res = await api.post("/add-term", data);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// Get app info data (terms & conditions, privacy policy, app info)
export const getTnc = async () => {
    try {
        const res = await api.get("/list-terms");
        return res.data || [];
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// Update app info data
export const updateTnc = async (data) => {
    try {
        const res = await api.put("/edit-term", data);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// QnA API endpoints
export const createQna = async (data) => {
    try {
        const res = await api.post("/add-faq", data);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const getQnaList = async () => {
    try {
        const res = await api.get("/list-faq");
        console.log(res.data);
        return res.data || [];
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const getQnaById = async (id) => {
    try {
        const res = await api.get(`/view-faq?id=${id}`);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const updateQna = async (data) => {
    try {
        const res = await api.put("/edit-faq", data);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const deleteQna = async (id) => {
    try {
        const res = await api.delete(`/delete-faq?id=${id}`);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

// About Us API endpoints
export const createAboutUs = async (data) => {
    try {
        const res = await api.post("/about-us", data);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const getAboutUs = async (id) => {
    try {
        const res = await api.get(`/list-about-us`);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const updateAboutUs = async (data) => {
    try {
        const res = await api.put(`/edit-about-us?id=${data.id}`, data);
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}